<template>
    <div>
        <div style="padding: 0 20px">
            <!--    新增角色按钮-->
            <div class="top">
                <div>
                    <el-button type="primary" @click="dialogAddVisible = true" style="width: 96px">新增角色</el-button>
                </div>
            </div>
            <!--    角色信息表格-->
            <div>
                <el-table :data="roleData"
                          v-loading="loading"
                          :header-cell-style="{'padding-left': '8%'}"
                          :cell-style="{'padding-left': '8%'}">
                    <el-table-column prop="roleName" label="角色名称"></el-table-column>
                    <el-table-column label="创建时间">
                        <template slot-scope="scope">
                            <span> {{ scope.row.createDate.slice(0,19) }} </span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button type="text" @click="editRoleData(scope.row)">编辑信息</el-button>
                            <el-button type="text" @click="permissionOpen(scope.row)">编辑权限</el-button>
                            <el-button type="text" class="delete-button" @click="deleteRole(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pagination">
                <el-pagination
                        background
                        layout="total, prev, pager, next"
                        :current-page="pageNum"
                        :page-size="pageSize"
                        :total="total"
                        @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>

<!--    新增角色弹窗-->
        <el-dialog title="新增角色" :visible.sync="dialogAddVisible" width="520px"
                   :close-on-click-modal="false" :before-close="cancelAdd">
            <el-form :model="addRole" :rules="rules" ref="addRole" label-width="80px" size="small">
                <el-form-item label="角色名称" prop="roleName">
                    <el-input v-model="addRole.roleName" class="width282"></el-input>
                </el-form-item>
<!--                <el-form-item label="角色描述" prop="describe">-->
<!--                    <el-input v-model="addRole.roleDescribe" class="width282"></el-input>-->
<!--                </el-form-item>-->
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelAdd" style="width: 76px">取消</el-button>
                <el-button type="primary" @click="confirmAdd" style="width: 76px">确定</el-button>
            </div>
        </el-dialog>

<!--        编辑角色弹窗-->
        <el-dialog title="编辑角色" :visible.sync="dialogEditVisible" width="520px"
                   :close-on-click-modal="false" :before-close="cancelEdit">
            <el-form :model="editRole" :rules="rules" ref="editRole" label-width="80px">
                <el-form-item label="角色名称" prop="roleName">
                    <el-input v-model="editRole.roleName" class="width282" size="small"></el-input>
                </el-form-item>
<!--                <el-form-item label="角色描述" prop="describe">-->
<!--                    <el-input v-model="editRole.roleDescribe" class="width282"></el-input>-->
<!--                </el-form-item>-->
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelEdit" style="width: 76px">取消</el-button>
                <el-button type="primary" @click="editConfirm" style="width: 76px;">确定</el-button>
            </div>
        </el-dialog>

        <el-drawer size="520px" title="权限配置" :visible.sync="permissionAddVisible" direction="rtl">
            <div class="permission">
                <el-scrollbar style="height: 100%;padding: 0">
                    <div class="permission-in">
                        <span>权限配置:</span>
                        <el-tree
                                v-if="permissionAddVisible"
                                :data="result_list"
                                :props="props"
                                show-checkbox
                                default-expand-all
                                @check-change="handleCheckChange"
                                node-key="menuId"
                                ref="rootTree">
                        </el-tree>
                    </div>
                </el-scrollbar>
            </div>
            <div class="dialog-foot-bottom">
                <el-button @click="permissionAddVisible = false" style="width: 76px">取消</el-button>
                <el-button type="primary" @click="savePermission" style="width: 76px">保存</el-button>
            </div>
        </el-drawer>
    </div>
</template>

<script type="text/javascript">
    export default {
        data() {
            return {
                // token
                authorization:localStorage.getItem('authorization'),
                pageNum: 1,
                pageSize: 10,
                total: 0,
                result_list: [],
                permissionList: [],
                // 列表数据
                roleData: [],
                loading: true,
                // 新增角色弹框开关
                dialogAddVisible: false,
                // 新增弹框表单数据
                addRole: {
                    roleKind: '2',
                    roleName:'',
                    // roleDescribe: '',
                },
                // 新增弹框表单验证
                rules: {
                    roleName: [{required: true, message: '请输入角色名称',trigger: 'blur'}],
                    // dispose: [{type: 'array',required: true, message: '请至少选择一项',trigger: 'change'}],
                },
                // 权限设置弹窗
                permissionAddVisible:false,
                getMenuList:[],
                getPermissionList:[],
                rolePermission: {
                    roleId: '',
                    menu_list: [],
                    permission_list: [],
                },
                props: {
                    label: 'menuCaption',
                    children: 'children'
                },

                // 编辑角色弹窗开关
                dialogEditVisible: false,
                // 编辑角色弹窗表单数据
                editRole: {
                    roleId: '',
                    roleKind: '',
                    roleName: '',
                    roleDescribe: '',
                },
                // 编辑角色弹窗Tree组件默认选中菜单
                defaultMenuId: [],
            }
        },
        methods: {
            // 查询角色列表
            queryRole() {
                this.loading = true
                this.axios.get('/api-u/10023/100060/' + this.pageNum + '/' + this.pageSize,{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res =>{
                    if (res.data.code === 10000) {
                        if (res.data.data.list === null) {
                            this.$message.info('暂无角色')
                        }
                        this.roleData = res.data.data.list
                        this.total = res.data.data.total
                    }  else {
                        this.$message.error(res.data.message)
                        this.total = 0
                        this.roleData = []
                    }
                    this.loading = false
                }).catch(error => {
                    this.total = 0
                    this.roleData = []
                    this.loading = false
                })
            },
            // 换页
            handlePageChange(val) {
                this.pageNum = val
                this.queryRole()
            },
            // 获取菜单
            queryMenu() {
                return new Promise((resolve, reject) => {
                    this.axios.get('/api-b/10025/100054', {
                        headers: {
                            Authorization: this.authorization
                        }
                    }).then(res => {
                        if(res.data.code === 10000) {
                            resolve()
                            this.result_list = res.data.data.result_list
                        } else {
                            this.$message.error(res.data.message)
                        }
                    }).catch(error => {
                        this.$message.error(error.message)
                        reject()
                    })
                })
            },
            // 获取所有权限
            queryPermission() {
                return new Promise((resolve, reject) => {
                    this.axios.get('/api-u/10022/100156',{
                        headers:{
                            Authorization: this.authorization
                        }
                    }).then(res => {
                        if (res.data.code === 10000) {
                            this.permissionList = res.data.data
                            resolve()
                        } else {
                            this.$message.error(res.data.message)
                        }
                    }).catch(error => {
                        reject()
                    })
                })
            },
            // 将菜单与权限组合
            getTree() {
                Promise.all([this.queryMenu(),this.queryPermission()]).then(() => {
                    for(let i=0;i<this.permissionList.length; i++) {
                        let item = this.permissionList[i].menuId
                        this.permissionList[i].menuId = this.permissionList[i].permissionId
                        this.permissionList[i].permissionId = item
                        this.permissionList[i].menuCaption = this.permissionList[i].permissionDesc
                        for (let j=0; j<this.result_list.length; j++) {
                            if (this.permissionList[i].permissionId === this.result_list[j].menuId) {
                                this.result_list[j].children.push(this.permissionList[i])
                            } else {
                                for (let k=0; k<this.result_list[j].children.length; k++) {
                                    if (this.permissionList[i].permissionId === this.result_list[j].children[k].menuId) {
                                        this.result_list[j].children[k].children.push(this.permissionList[i])
                                    }
                                }
                            }
                        }
                    }
                }).catch(error => {
                    this.$message.error(error)
                })
            },
            // 取消新增
            cancelAdd() {
                this.dialogAddVisible = false
                this.$nextTick(() => {
                    this.$refs.addRole.resetFields()
                })
            },
            // 新增角色确定按钮
            confirmAdd(){
                this.$refs.addRole.validate(valid => {
                    if (valid) {
                        let params ={
                            roleKind: this.addRole.roleKind,
                            roleName: this.addRole.roleName
                        }
                        this.axios.post('/api-u/10023/100039', params,{
                            headers:{
                                Authorization: this.authorization
                            }
                        }).then(res =>{
                            if(res.data.code === 10000) {
                                this.$message.success(res.data.message);
                                this.dialogAddVisible = false;
                                this.getTree()
                                setTimeout(() => {
                                    this.permissionAddVisible = true
                                    this.rolePermission.roleId = res.data.data.roleId
                                    this.$nextTick(() => {
                                        this.$refs.addRole.resetFields();
                                    })
                                },300)
                                // 查询现有角色
                                this.queryRole()
                            } else {
                                this.$message.error(res.data.message)
                            }
                        })
                    } else {
                        this.$message.error('请填写角色名称')
                    }
                })
            },
            // 新增Tree组件选中状态选项的值
            handleCheckChange() {
                this.rolePermission.menu_list = []
                this.rolePermission.permission_list = []
                let menu = this.$refs.rootTree.getCheckedNodes().concat(this.$refs.rootTree.getHalfCheckedNodes())
                for (let i=0; i<menu.length; i++) {
                    if (menu[i].permissionId === undefined) {
                        this.rolePermission.menu_list.push(menu[i].menuId)
                    } else {
                        this.rolePermission.permission_list.push(menu[i].menuId)
                    }
                }
            },
            // 角色编辑按钮,将角色相关数据展示在弹窗表单内
            editRoleData(data){
                this.dialogEditVisible = true;
                this.editRole = JSON.parse(JSON.stringify(data))
            },
            cancelEdit() {
                this.dialogEditVisible = false
                this.$nextTick(() => {
                    this.$refs.editRole.clearValidate()
                })
            },
            // 角色编辑确定按钮
            editConfirm() {
                this.$refs.editRole.validate(valid => {
                    if(valid) {
                        let param = {
                            roleId: this.editRole.roleId,
                            roleKind: this.editRole.roleKind,
                            roleName: this.editRole.roleName
                        }
                        // 请求修改角色信息
                        this.axios.put('/api-u/10023/100041', param,{
                            headers:{
                                Authorization: this.authorization
                            }
                        }).then(res =>{
                            if(res.data.code === 10000) {
                                this.dialogEditVisible = false
                                this.$message.success(res.data.message);
                                // 查询现有角色
                                this.queryRole()
                            }  else {
                                this.$message.error(res.data.message)
                            }
                        })
                    }else {
                        this.$message.error('请填写角色名称')
                    }
                })
            },
            // 删除角色
            deleteRole(data) {
                const h = this.$createElement;
                this.$msgbox({
                    message: h('div',{class:'message-box'}, [
                        h('div', { class: 'message-title-box'}, [
                            h('i', { class:'el-icon-warning message-box-icon' }, ''),
                            h('span', { class:'message-box-title'}, '确认要删除该角色吗？ '),
                        ]),
                        h('div', null, [
                            h('span', { class:'message-box-main'}, '删除角色后，对应的账号将无法正常登陆。'),
                        ]),
                    ]),
                    showCancelButton: true,
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                }).then(() => {
                    this.axios.delete('/api-u/10023/100040/' + data.roleId, {
                        headers: {
                            Authorization: this.authorization
                        }
                    }).then(res => {
                        if (res.data.code === 10000) {
                            this.$message.success(res.data.message);
                            // 查询现有角色
                            this.queryRole()
                        } else {
                            this.$message.error(res.data.message)
                        }
                    })
                }).catch(error => {})
            },
            // 列表打开权限编辑
            permissionOpen(data) {
                let treeList = []
                this.rolePermission.roleId = data.roleId
                this.getTree()
                Promise.all([this.getRoleMenu(),this.getRolePermission()]).then(() => {
                    treeList = this.getMenuList.concat(this.getPermissionList)
                    this.permissionAddVisible = true
                    setTimeout(() => {
                        treeList.forEach(value => {
                            this.$refs.rootTree.setChecked(value, true, false);
                        });
                    }, 300);
                }).catch(error => {
                    this.$message.error(error)
                })
            },
            // 获取角色菜单
            getRoleMenu() {
                return new Promise((resolve, reject) => {
                    this.axios.get('/api-b/10025/100057/' + this.rolePermission.roleId,{
                        headers: {
                            Authorization: this.authorization
                        }
                    }).then(res => {
                        if (res.data.code === 10000) {
                            this.getMenuList = res.data.data
                            resolve()
                        } else {
                            this.$message.error(res.data.message)
                        }
                    }).catch(error => {
                        reject()
                    })
                })
            },
            // 获取角色权限
            getRolePermission() {
                return new Promise((resolve, reject) => {
                    this.getPermissionList = []
                    this.axios.get('/api-u/10023/100043/' + this.rolePermission.roleId,{
                        headers: {
                            Authorization: this.authorization
                        }
                    }).then(res => {
                        if (res.data.code === 10000) {
                            for (let i=0;i<res.data.data.length; i++) {
                                this.getPermissionList.push(res.data.data[i].permissionId)
                            }
                            resolve()
                        } else {
                            this.$message.error(res.data.message)
                        }
                    }).catch(error => {
                        reject()
                    })
                })
            },
            // 提交菜单列表
            menuUp() {
                return new Promise((resolve, reject) => {
                    let params = {
                        roleId: this.rolePermission.roleId,
                        param_list: this.rolePermission.menu_list
                    }
                    this.axios.post('/api-b/10025/100055/',params,{
                        headers: {
                            Authorization: this.authorization
                        }
                    }).then(res => {
                        if (res.data.code === 10000) {
                            resolve()
                        } else {
                            this.$message.error(res.data.message)
                        }
                    }).catch(error => {
                        reject()
                    })
                })
            },
            // 提交权限列表
            permissionUp(){
                return new Promise((resolve, reject) => {
                    if (this.rolePermission.permission_list.length !== 0) {
                        let params = {
                            roleId: this.rolePermission.roleId,
                            param_list: this.rolePermission.permission_list
                        }
                        this.axios.put('/api-u/10023/100042/',params,{
                            headers: {
                                Authorization: this.authorization
                            }
                        }).then(res => {
                            if (res.data.code === 10000) {
                                resolve()
                            } else {
                                reject()
                            }
                        }).catch(error => {
                            reject(error)
                        })
                    } else {
                        resolve()
                    }
                })
            },
            // 确认修改角色权限
            savePermission() {
                Promise.race([this.menuUp(),this.permissionUp()]).then(() => {
                    this.$message.success('角色权限分配成功')
                    this.permissionAddVisible = false
                })
            }
        },
        watch: {

        },
        created() {
            // 获取表格所需角色信息
            this.queryRole()
        }
    }
</script>


<style>
    .el-button--small {
        width: 65px;
        height: 32px;
        font-size: 14px;
    }
    .el-button--primary:hover {
        background:rgba(120,180,255,1)!important;
        color: #FFFFFF!important;
        border: none!important;
    }
    .el-button--primary:focus {
        background:rgba(57,129,221,1)!important;
        color: #FFFFFF!important;
        border: none!important;
    }
    :focus {
        outline: none;
    }
    .el-drawer__header>:first-child {
        margin-top: -20px;
    }
    .el-drawer__header {
        height: 34px;
        background: rgba(97,167,255,1);
        margin-bottom: 0;
        color: #FFFFFF;
        font-size: 14px;
    }
    .el-drawer__close-btn {
        margin-top: -20px;
        color: #FFFFFF;
        font-size: 14px;
    }
    .permission .el-scrollbar__wrap{
        overflow-x: hidden;
    }
</style>

<style scoped>
    .top {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        margin-top: 12px;
        height: 52px;
    }
    .width282 {
        width: 282px;
    }
    .permission {
        display: flex;
        flex-direction: row;
        padding: 20px 0 0 20px;
        height: 861px;
        border:1px solid rgba(227,227,227,1);
    }
    .permission-in {
        width: 496px;
        font-size: 14px;
        color: #606266;
        display: flex;
        flex-direction: row;
    }
    .dialog-foot-bottom {
        position: absolute;
        bottom: 13px;
        right: 20px;
    }
    .delete-button {
        margin-left: 20px;
        color: rgba(255,75,75,1) !important;
    }
    .delete-button:hover {
        color: rgba(255,75,75,0.8) !important;
    }
    .delete-button:focus {
        color: rgba(215,37,41,1) !important;
    }

</style>